function ExcelDetails() {

    /// <summary>
    /// This object provides client-side functions for the Widget.Report.Details visual. <br/>
   /// <br/>
    /// Author: MWI<br />
    /// Date: 12.05.2016<br />
    /// Copyright ©: EUDT GmbH 2016 <br />
    /// Version-History:<br />
    /// *** v1.0.2 - 09.01.2017                                               *<br />
    /// **********************************************************************<br />
    /// * - ESLint changes                                                    *<br />
    /// **********************************************************************<br />
    /// *** v1.0.1 - 06.06.2016                                               *<br />
    /// **********************************************************************<br />
    /// * - added support for more buttons                                   *<br />
    /// * - documentation                                                    *<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 12.05.2016                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>
   
}
ExcelDetails.prototype = new window.vcTemplate();
ExcelDetails.prototype.init = function () {
    /// <summary>
    /// This function inits the the Object <br/>
    /// it does nothing more than adding the clickhandler 
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
        me.showInfo("", "", false);
        me.initClickHandler();
        me.wiz = me.visual.find("#vc-wizard-excel").vcWizard({ stepWidth: 451 });

        //me.wiz = me.visual.find("#vc-wizard-excel").vcWizard({ stepWidth: 298 });
        me.visual.find(".excel-step[data-projectdetail='excel']").trigger("click");

        //me.visual.find(".button-toggle:first").trigger("click");
        return true;
    } catch (ex) {
        me.writeError('ExcelDetails.init', ex);
        return false;
    }

};

ExcelDetails.prototype.loadDetailForms = function () {

    var me = this;
    var type;
    try {
        if (me.error) { return false; }
        //init list entry click handler
        //if (!me.visual.find('.vc-wizard-stepl.active').button( "option", "disabled" )){
        type = me.visual.find('.excel-step.active').attr("data-projectdetail");
            me.vcVisual.setShowFullscreen(false);
            me.vcVisual.setShowHeaderMenu(false);
            me.visual.find("#detailContent").html(me.vcC.getLoadingIcon());
        me.visual.find("#project-settings-name, #user-assign").html("");
            switch (type) {

                case "excel":
                    me.vcVisual.addVisualContentByName('d', 'WIDGET_GALLERY_UPLOAD', 'etailContent', window.getCurrentTimestamp(), 600, 1000,
                        JSON.stringify({ mediaCategory: "REPTEMPLATE", editable: true }),
                        JSON.stringify({ 'mediaId': me.ids.mediaId }),me.deviceType);
                    break;

                case "sheet":
                    me.vcVisual.addVisualContentByName('de', 'WIDGET_REPORT_SHEET_MANAGEMENT', 'tailContent', window.getCurrentTimestamp(), 1100, 1088, JSON.stringify({ "retID": me.ids.rrid }), "", me.deviceType);
                break;
       
             
            }
        //}

        return true;

    } catch (ex) { me.writeError("ExcelDetails.loadDetailForms", ex); return false; }
};
ExcelDetails.prototype.doEvent = function(event) {
    /// <summary>
    /// calls the button back function when a project got deleted
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
        switch (event.msg) {
        case "GALLERY_CHANGED":
            me.visual.find(".excel-step[data-projectdetail='sheet']").trigger("click");
            break;
        }
        return true;
    } catch (ex) {
        me.writeError("ReportDetails.doEvent", ex);
        return false;
    }
};

ExcelDetails.prototype.btnBack = function () {
    /// <summary>
    /// Handles the click of the back button <br/>
    /// by calling the webservice and calling the overview list again, needs to be 
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }
        me.visual.hide();
        window._VCMQ.produce(me.visual, me.vcgid, 'REP_DET_BACK', {});
        return true;
    } catch (ex) {
        me.writeError('ExcelDetails.btnBack', ex);
        return false;
    }
};
ExcelDetails.prototype.initClickHandler = function () {
    var me = this;
    try {
        if (me.error) { return false; }
        me.visual.find(".excel-step").off("click").on("click", function () {
            //me.visual.find(".button-toggle").toggleClass("button-toggle-active", false);
            //$(this).toggleClass("button-toggle-active");
            
            me.wiz.vcWizard("setActive", $(this).attr("data-step")-1);
            me.loadDetailForms();
        });
        return true;
    } catch (ex) {
        me.writeError('ExcelDetails.initClickHandler', ex);
        return false;
    }
};

ExcelDetails.prototype.specificInfoHandling = function (bError) {
    /// <summary>
    /// This function  hides/fades out content on error state. 
    /// </summary>
    var me = this;
    try {
        if (bError) {
            me.visual.find('.toggle-button, #divContent').hide();
        }
        return true;
    } catch (ex) {
        me.writeError('specificInfoHandling', ex);
        return false;
    }
};